import {
  Form,
  NavDropdown,
  Nav,
  Button,
  Container,
  Navbar,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import styles from "../Assets/Scss/home/navbar.module.scss";

const NavbarC = () => {
  return (
    <Container>
      <Navbar
        expand="lg"
        className={`bg-body-tertiary mt-4 rounded-4 ${styles.navbar}`}
      >
        <Container fluid>
          <Link to="/">
            <Navbar.Brand href="/">CFC</Navbar.Brand>
          </Link>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-2 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <Link to="/">
                <Nav.Link href="#action1">Home</Nav.Link>
              </Link>

              <NavDropdown title="Info" id="navbarScrollingDropdown">
                <NavDropdown.Item href="#action4">Qmimet</NavDropdown.Item>

                <NavDropdown.Item href="/orari">Orari</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Form className="d-flex">
              <Link to="/login">
                <Button variant="outline-danger">Login</Button>
              </Link>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Container>
  );
};

export default NavbarC;
